const { REACT_APP_CONTEXT_PATH } = process.env;

export const closeTicketApi = () => {
  return {
    apiUrl: REACT_APP_CONTEXT_PATH + `/ticket/close`,
  };
};
